module.exports = __webpack_public_path__ + "static/media/OB.aa1b4a1a.webp";